import {PIXI} from '@colonist/pixi'
import {AnimatedSpriteView} from '../../ui_canvas_engine/AnimatedSpriteView'
import {UIGameSpriteHandler} from '../../UIGameSpriteHandler'

export class UIGameTradeOfferWaitIconView {
    private readonly parentContainer: PIXI.Container
    private waitIcon: AnimatedSpriteView

    constructor(parentContainer: PIXI.Container, playerName: string, iconXScalar: number) {
        this.parentContainer = parentContainer

        const backgroundSize = parentContainer.width * 0.6

        this.createAnimatedWaitIcon(backgroundSize, iconXScalar)

        this.waitIcon.setTip({key: 'strings:colonistCommon.utils.emptyString'}, [{key: 'strings:game.tooltips.tradeOfferCreatingCounterOffer', options: {playerUsername: playerName}}])
        this.hide()
    }

    show() {
        this.waitIcon.play()
        const alreadyExists = this.waitIcon.parent != undefined
        if(alreadyExists) return
        this.parentContainer.addChild(this.waitIcon)
    }

    hide() {
        this.waitIcon.stop()
        const isRemoved = this.waitIcon.parent == undefined
        if(isRemoved) return
        this.parentContainer.removeChild(this.waitIcon)
    }

    restart() {
        const isRemoved = this.waitIcon.parent == undefined
        if(isRemoved) return
        const initialFrame = 0
        this.waitIcon.gotoAndPlay(initialFrame)
    }

    destroy() {
        if(this.waitIcon.destroyed) return
        this.waitIcon.destroy({children: true})
    }

    private createAnimatedWaitIcon(backgroundSize: number, iconXScalar: number) {
        const waitIconSpreadsheet = UIGameTradeOfferWaitIconView.getWaitIconAnimatedSpreadsheet()
        if(waitIconSpreadsheet == undefined) return

        const waitIconTexture = UIGameTradeOfferWaitIconView.getWaitIconFirstTexture(waitIconSpreadsheet)

        const iconWidth = backgroundSize
        const iconHeight = iconWidth * (waitIconTexture.height / waitIconTexture.width)

        const iconX = this.parentContainer.width * iconXScalar
        const iconY = -iconHeight / 3

        this.waitIcon = new AnimatedSpriteView(iconX, iconY, iconWidth, iconHeight, this.parentContainer, waitIconSpreadsheet.animations['waitIcon'])
        this.waitIcon.animationSpeed = 0.3
    }

    private static getWaitIconAnimatedSpreadsheet(): PIXI.Spritesheet | undefined {
        const sheetName = 'game_spritesheet_wait_icon_mobile'
        return UIGameSpriteHandler.getSpritesheet(sheetName)
    }

    private static getWaitIconFirstTexture(sheet: PIXI.Spritesheet): PIXI.Texture {
        return sheet.textures['waitIcon_mobile_01.png']
    }
}
